import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "account" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Voornaam "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Achternaam "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Adres", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Postcode", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Plaats", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("E-mailadres "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Telefoonnummer", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Gebruikersnaam", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Nieuw wachtwoord instellen?", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Wachtwoord", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Wachtwoord bevestigen", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Cache", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je jouw cache wilt wissen?", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Notificaties van medewerkers", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ls } from '@/ls'
import { authStore } from '@/stores/auth'
import { settingsStore } from '@/stores/settings'

import PageTitleBar from '@/components/PageTitleBar.vue'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import { can } from '@/globalFunctions'


export default /*#__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {

const router = useRouter()
const loading = ref(false)

const newPassword = ref(false)
const password = ref(null)
const passwordConfirmation = ref(null)
const errors = ref<{[key: string]: string[]}>({})
const employeeNotifications = ref(settingsStore().getSetting('employeeNotifications', true) as boolean)

function save () : void {
  loading.value = true
  axios.post(process.env.VUE_APP_API_URL + '/users/details', {
    firstname: authStore().user.firstname,
    lastname: authStore().user.lastname,
    address: authStore().user.address,
    zipcode: authStore().user.zipcode,
    city: authStore().user.city,
    email: authStore().user.email,
    phone: authStore().user.phone,
    password: password.value,
    password_confirmation: passwordConfirmation.value
  }).then((r) => {
    ls.set('authUser', r.data.user)
    newPassword.value = false
    password.value = null
    passwordConfirmation.value = null
    errors.value = {}
    notification.success({ message: 'Gegevens opgeslagen.', description: 'Je gegevens zijn succesvol opgeslagen.', duration: 3 })
  }).catch((e) => {
    if (e.response.status === 422) {
      errors.value = e.response.data.errors
      notification.error({ message: 'Fout tijdens het opslaan!', description: 'Niet alle velden zijn correct ingevuld.', duration: 3 })
    } else {
      notification.error({ message: 'Fout tijdens het opslaan!', description: 'Er is iets mis gegaan. Probeer het later nog een keer.', duration: 3 })
    }
  }).finally(() => {
    loading.value = false
  })
}

function updateEmployeeNotifications (checked: boolean) : void {
  employeeNotifications.value = settingsStore().setSetting('employeeNotifications', checked, true) as boolean
}

function clearCache () : void {
  const lsKeys = ls.getAllKeys()
  const lsKeysNotToClear = ['token', 'user', 'timeRegistrationProjects', 'personalProjects']

  lsKeys.forEach((lsKey:string) => {
    if (!lsKeysNotToClear.includes(lsKey)) {
      ls.remove(lsKey)
    }
  })

  notification.success({ message: 'Cache gewist.', description: 'De cache is succesvol gewist.', duration: 3 })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode("Account")
      ]),
      subtitle: _withCtx(() => [
        _createTextVNode("Jouw gegevens")
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [
            _createTextVNode("Opslaan")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Terug naar dashboard")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: [16, 16] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: {span: 24},
          sm: {span: 24},
          md: {span: 24},
          lg: {span: 24}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, { title: "Gegevens" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, { gutter: [16, 16] }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              xs: {span: 24},
                              sm: {span: 24},
                              md: {span: 24},
                              lg: {span: 12}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_2,
                                _createVNode(_component_a_input, {
                                  type: "text",
                                  value: _unref(authStore)().user.firstname,
                                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(authStore)().user.firstname) = $event))
                                }, null, 8, ["value"]),
                                (errors.value.firstname)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(errors.value.firstname, (error, index) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        class: "warning-red",
                                        key: index
                                      }, _toDisplayString(error), 1))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, {
                              xs: {span: 24},
                              sm: {span: 24},
                              md: {span: 24},
                              lg: {span: 12}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_3,
                                _createVNode(_component_a_input, {
                                  type: "text",
                                  value: _unref(authStore)().user.lastname,
                                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(authStore)().user.lastname) = $event))
                                }, null, 8, ["value"]),
                                (errors.value.lastname)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(errors.value.lastname, (error, index) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        class: "warning-red",
                                        key: index
                                      }, _toDisplayString(error), 1))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, { gutter: [16, 16] }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              xs: {span: 24},
                              sm: {span: 24},
                              md: {span: 24},
                              lg: {span: 12}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_4,
                                _createVNode(_component_a_input, {
                                  type: "text",
                                  value: _unref(authStore)().user.address,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(authStore)().user.address) = $event))
                                }, null, 8, ["value"]),
                                (errors.value.address)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(errors.value.address, (error, index) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        class: "warning-red",
                                        key: index
                                      }, _toDisplayString(error), 1))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, {
                              xs: {span: 24},
                              sm: {span: 24},
                              md: {span: 24},
                              lg: {span: 6}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5,
                                _createVNode(_component_a_input, {
                                  type: "text",
                                  value: _unref(authStore)().user.zipcode,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(authStore)().user.zipcode) = $event))
                                }, null, 8, ["value"]),
                                (errors.value.zipcode)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(errors.value.zipcode, (error, index) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        class: "warning-red",
                                        key: index
                                      }, _toDisplayString(error), 1))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, {
                              xs: {span: 24},
                              sm: {span: 24},
                              md: {span: 24},
                              lg: {span: 6}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6,
                                _createVNode(_component_a_input, {
                                  type: "text",
                                  value: _unref(authStore)().user.city,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(authStore)().user.city) = $event))
                                }, null, 8, ["value"]),
                                (errors.value.city)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(errors.value.city, (error, index) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        class: "warning-red",
                                        key: index
                                      }, _toDisplayString(error), 1))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, { gutter: [16, 16] }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              xs: {span: 24},
                              sm: {span: 24},
                              md: {span: 24},
                              lg: {span: 12}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7,
                                _createVNode(_component_a_input, {
                                  type: "text",
                                  value: _unref(authStore)().user.email,
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(authStore)().user.email) = $event))
                                }, null, 8, ["value"]),
                                (errors.value.email)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(errors.value.email, (error, index) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        class: "warning-red",
                                        key: index
                                      }, _toDisplayString(error), 1))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, {
                              xs: {span: 24},
                              sm: {span: 24},
                              md: {span: 24},
                              lg: {span: 12}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8,
                                _createVNode(_component_a_input, {
                                  type: "text",
                                  value: _unref(authStore)().user.phone,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(authStore)().user.phone) = $event))
                                }, null, 8, ["value"]),
                                (errors.value.phone)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(errors.value.phone, (error, index) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        class: "warning-red",
                                        key: index
                                      }, _toDisplayString(error), 1))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_divider),
                        _createVNode(_component_a_row, { gutter: [16, 16] }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              xs: {span: 24},
                              sm: {span: 24},
                              md: {span: 24},
                              lg: {span: 12}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9,
                                _hoisted_10,
                                _createTextVNode(" " + _toDisplayString(_unref(authStore)().user.username), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, { gutter: [16, 16] }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              xs: {span: 24},
                              sm: {span: 24},
                              md: {span: 24},
                              lg: {span: 12}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11,
                                _hoisted_12,
                                _createVNode(_component_a_switch, {
                                  checked: newPassword.value,
                                  onChange: _cache[8] || (_cache[8] = ($event: any) => (newPassword.value = !newPassword.value))
                                }, null, 8, ["checked"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (newPassword.value)
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 0,
                              gutter: [16, 16]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, {
                                  xs: {span: 24},
                                  sm: {span: 24},
                                  md: {span: 24},
                                  lg: {span: 12}
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_13,
                                    _createVNode(_component_a_input, {
                                      type: "password",
                                      autocomplete: "off",
                                      value: password.value,
                                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((password).value = $event))
                                    }, null, 8, ["value"]),
                                    (errors.value.password)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(errors.value.password, (error, index) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            class: "warning-red",
                                            key: index
                                          }, _toDisplayString(error), 1))
                                        }), 128))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_col, {
                                  xs: {span: 24},
                                  sm: {span: 24},
                                  md: {span: 24},
                                  lg: {span: 12}
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_14,
                                    _createVNode(_component_a_input, {
                                      type: "password",
                                      autocomplete: "off",
                                      value: passwordConfirmation.value,
                                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((passwordConfirmation).value = $event))
                                    }, null, 8, ["value"]),
                                    (errors.value.password_confirmation)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(errors.value.password_confirmation, (error, index) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            class: "warning-red",
                                            key: index
                                          }, _toDisplayString(error), 1))
                                        }), 128))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, { title: "Instellingen" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, { gutter: [16, 16] }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _hoisted_15,
                                _hoisted_16,
                                _createVNode(_component_a_popconfirm, {
                                  placement: "bottomLeft",
                                  "ok-text": "Ja",
                                  "cancel-text": "Nee",
                                  onConfirm: clearCache
                                }, {
                                  title: _withCtx(() => [
                                    _hoisted_17
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, { type: "primary" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Reset cache")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_unref(can)('construction_site_portal.colleague_notifications.edit'))
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 0,
                              gutter: [16, 16]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 12 }, {
                                  default: _withCtx(() => [
                                    _hoisted_18,
                                    _hoisted_19,
                                    _createVNode(_component_a_switch, {
                                      checked: employeeNotifications.value,
                                      onChange: updateEmployeeNotifications
                                    }, null, 8, ["checked"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})